import React from 'react';
import { useNavigate } from "react-router-dom";

// Fallback UI Component
function ErrorFallback() {
  const navigate = useNavigate();
  return (
    <div style={{ padding: "20px", textAlign: "center", color: "red" }}>
    <h2>Oops! Something went wrong.</h2>
    <p>Please try refreshing the page.</p>
    <button 
        onClick={() => navigate("/")} 
        style={{
          marginTop: "10px",
          padding: "10px 20px",
          background: "#007bff",
          color: "#fff",
          border: "none",
          cursor: "pointer",
          borderRadius: "5px"
        }}
      >
        Go to Home
      </button>
  </div>
  );
}

export default ErrorFallback